import { render } from "./toast-notification.vue?vue&type=template&id=a1be8dc0"
import script from "./toast-notification.vue?vue&type=script&lang=js"
export * from "./toast-notification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__